import styleInject from '#style-inject';styleInject(".az-copy-copied {\n  color: var(--az-palette-xanthus) !important;\n}\n")